import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MarketingMetric from './marketing-metric-model'
import {
  CreateMarketingMetricAsync,
  DeleteMarketingMetricAsync,
  LoadMarketingMetricsAsync,
} from './marketingMetric-thunk'
const initialState: marketingMetricSliceState = {
  marketingMetric: [],
  selected_marketingMetric: '',
  is_loading_marketingMetric: false,
  is_creating_marketingMetric: false,
  is_deleting_marketingMetric: false,
}
export interface marketingMetricSliceState {
  marketingMetric: MarketingMetric[]
  selected_marketingMetric?: string
  is_loading_marketingMetric: boolean
  is_creating_marketingMetric: boolean
  is_deleting_marketingMetric: boolean
}
export const marketingMetricSlice = createSlice({
  name: 'marketingMetric',
  initialState,
  reducers: {
    setSelectedmarketingMetric: (state, action) => {
      state.selected_marketingMetric = action.payload
    },
    clearStatemarketingMetric: (state) => {
      state.marketingMetric = []
      state.is_loading_marketingMetric = false
      state.is_creating_marketingMetric = false
      state.is_deleting_marketingMetric = false
    },
    mergemarketingMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_marketingMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.marketingMetric = merge(state.marketingMetric, payload) as any
        }
      }
    },

    add_marketingMetric: (state, action) => {
      if (action.payload) {
        state.marketingMetric = [...state.marketingMetric, action.payload]
      }
    },
    set_marketingMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.marketingMetric = state.marketingMetric.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMarketingMetricsAsync.pending, (state) => {
      state.is_loading_marketingMetric = true
    })
    builder.addCase(LoadMarketingMetricsAsync.fulfilled, (state, action) => {
      state.is_loading_marketingMetric = false
      if (action.payload) {
        state.marketingMetric = action.payload
      }
    })
    builder.addCase(LoadMarketingMetricsAsync.rejected, (state) => {
      state.is_loading_marketingMetric = false
    })
    builder.addCase(CreateMarketingMetricAsync.pending, (state) => {
      state.is_creating_marketingMetric = true
    })
    builder.addCase(CreateMarketingMetricAsync.fulfilled, (state) => {
      state.is_creating_marketingMetric = false
    })
    builder.addCase(CreateMarketingMetricAsync.rejected, (state) => {
      state.is_creating_marketingMetric = false
    })
    builder.addCase(DeleteMarketingMetricAsync.pending, (state) => {
      state.is_deleting_marketingMetric = true
    })
    builder.addCase(DeleteMarketingMetricAsync.fulfilled, (state, action) => {
      state.is_deleting_marketingMetric = false
      if (state.marketingMetric) {
        state.marketingMetric = state.marketingMetric.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMarketingMetricAsync.rejected, (state) => {
      state.is_deleting_marketingMetric = false
    })
  },
})

export const {
  clearStatemarketingMetric,
  setSelectedmarketingMetric,
  set_marketingMetric,
  mergemarketingMetric,
  add_marketingMetric,
} = marketingMetricSlice.actions

export const get_marketingMetric =
  (id?: string) =>
  (state: {
    marketingMetric: {
      marketingMetric: MarketingMetric[]
    }
  }): MarketingMetric | null => {
    let temp = state?.marketingMetric?.marketingMetric?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.marketingMetric?.marketingMetric[0] || null
  }
export const get_selected_marketingMetric = (state: {
  marketingMetric: marketingMetricSliceState
}): MarketingMetric | null => {
  let id = state?.marketingMetric?.selected_marketingMetric
  let temp = state?.marketingMetric?.marketingMetric?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_marketingMetric = (state: {
  marketingMetric: {
    marketingMetric: MarketingMetric[]
  }
}): MarketingMetric[] => {
  let temp = state?.marketingMetric?.marketingMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_marketingMetric_busy = (state: {
  marketingMetric: marketingMetricSliceState
}) => {
  return (
    state?.marketingMetric.is_deleting_marketingMetric ||
    state?.marketingMetric.is_loading_marketingMetric ||
    state?.marketingMetric.is_creating_marketingMetric
  )
}
export const is_deleting_marketingMetric_busy = (state: {
  marketingMetric: marketingMetricSliceState
}) => {
  return state?.marketingMetric.is_deleting_marketingMetric
}
export const is_loading_marketingMetric_busy = (state: {
  marketingMetric: marketingMetricSliceState
}) => {
  return state?.marketingMetric.is_loading_marketingMetric
}
export const is_creating_marketingMetric_busy = (state: {
  marketingMetric: marketingMetricSliceState
}) => {
  return state?.marketingMetric.is_creating_marketingMetric
}

export default marketingMetricSlice.reducer
